var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.177,
    cy: 12.7202,
    r: 12.5,
    fill: "#D9EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.177 12.7202C18.177 15.4816 15.9384 17.7202 13.177 17.7202C10.4156 17.7202 8.177 15.4816 8.177 12.7202C8.177 9.95879 10.4156 7.72021 13.177 7.72021C15.9384 7.72021 18.177 9.95879 18.177 12.7202ZM19.177 12.7202C19.177 16.0339 16.4907 18.7202 13.177 18.7202C9.86329 18.7202 7.177 16.0339 7.177 12.7202C7.177 9.40651 9.86329 6.72021 13.177 6.72021C16.4907 6.72021 19.177 9.40651 19.177 12.7202ZM12.577 9.72021L12.677 13.9202H13.6699L13.777 9.72021H12.577ZM13.177 15.7202C13.5084 15.7202 13.777 15.4516 13.777 15.1202C13.777 14.7888 13.5084 14.5202 13.177 14.5202C12.8457 14.5202 12.577 14.7888 12.577 15.1202C12.577 15.4516 12.8457 15.7202 13.177 15.7202Z",
    fill: "#0B71ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.0e1765076c9fdb8ee054c75f5d527dc9.svg";
export { ForwardRef as ReactComponent };